<template>
    <CHeader fixed with-subheader light>
        <CToggler in-header
                  class="ml-3 d-lg-none"
                  @click="$store.commit('toggleSidebarMobile')" />
        <CToggler in-header
                  class="ml-3 d-md-down-none"
                  @click="$store.commit('toggleSidebarMobile')" />
        <!--<CToggler in-header
              class="ml-3 d-md-down-none"
              @click="$store.commit('toggleSidebarDesktop')" />-->
    <CHeaderBrand class="d-lg-none">
        <h3><b> <font color="Green">CDE</font> <font color="gray">COAL</font></b></h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
            <CHeaderNavItem class="px-3">
                <h2><b> <font color="Green">CDE</font> <font color="gray">COAL</font></b></h2>
            </CHeaderNavItem>
        </CHeaderNav>
    </CHeader>
</template>
<script>
    //import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

    export default {
        name: 'TheHeader',
        components: {
            //TheHeaderDropdownAccnt
        }
    }
</script>
